export const MIN_SPACER_SIZE = 0;
//# sourceMappingURL=constants.js.map